// Landing Gate - Route /
import { Link } from 'react-router-dom';

export default function LandingGate() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-6">
      <div className="max-w-4xl w-full">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-amber-400 mb-4">
            🏆 Holy Grail
          </h1>
          <p className="text-2xl text-slate-300 font-light">
            Affiliate Analytics Engine
          </p>
          <p className="text-slate-500 mt-2">
            Sistem Kurasi Produk Otomatis
          </p>
        </div>

        {/* Platform Selection Cards */}
        <div className="grid md:grid-cols-2 gap-8">
          {/* Shopee Portal Card */}
          <Link
            to="/shopee"
            className="group relative bg-gradient-to-br from-orange-500/20 to-orange-600/10 border-2 border-orange-500/30 rounded-2xl p-8 hover:border-orange-500 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-orange-500/20"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-orange-500/10 to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity" />
            
            <div className="relative z-10 text-center">
              <div className="text-8xl mb-6">🛒</div>
              <h2 className="text-3xl font-bold text-orange-400 mb-4">
                Portal Kurasi Shopee
              </h2>
              <p className="text-slate-400 mb-6">
                Akses 300 produk kurasi terbaik dari ekosistem Shopee
              </p>
              <div className="inline-flex items-center gap-2 px-6 py-3 bg-orange-500/20 border border-orange-500/50 rounded-lg text-orange-400 font-medium">
                Masuk ke Portal
                <span className="text-xl">→</span>
              </div>
            </div>
          </Link>

          {/* TikTok Portal Card */}
          <Link
            to="/tiktok"
            className="group relative bg-gradient-to-br from-pink-500/20 to-pink-600/10 border-2 border-pink-500/30 rounded-2xl p-8 hover:border-pink-500 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-pink-500/20"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-pink-500/10 to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity" />
            
            <div className="relative z-10 text-center">
              <div className="text-8xl mb-6">🎵</div>
              <h2 className="text-3xl font-bold text-pink-400 mb-4">
                Portal Kurasi TikTok
              </h2>
              <p className="text-slate-400 mb-6">
                Akses 300 produk kurasi terbaik dari ekosistem TikTok Shop
              </p>
              <div className="inline-flex items-center gap-2 px-6 py-3 bg-pink-500/20 border border-pink-500/50 rounded-lg text-pink-400 font-medium">
                Masuk ke Portal
                <span className="text-xl">→</span>
              </div>
            </div>
          </Link>
        </div>

        {/* Footer */}
        <div className="text-center mt-12 text-slate-500 text-sm">
          <p>🔒 Landing Gate Compliant • Tidak ada perbandingan platform</p>
          <p className="mt-2">⏰ Pipeline Funnel: Jam 02.00 WIB</p>
        </div>
      </div>
    </div>
  );
}